import { validateEntityXml } from './entitiesListUtils';
import { validateFormXml } from './formsListUtils';
import { STANDALONE_DASHBOARD_TYPES } from '../constants/StandaloneLayoutConstants';
import { validateReportXml } from '../report-designer/utils/report-designer.utils';
import { validateReportModelXml } from '../report-model-designer/utils/report-model-designer-utils';

export const getCreateButtonText = (dashboardType) => {
  switch (dashboardType) {
    case STANDALONE_DASHBOARD_TYPES.ENTITIES:
      return 'Create Entity';
    case STANDALONE_DASHBOARD_TYPES.FORMS:
      return 'Create Form';
    case STANDALONE_DASHBOARD_TYPES.SAVED_SEARCHES:
      return 'Create Saved Search';
    case STANDALONE_DASHBOARD_TYPES.REPORTS:
      return 'Create Report';
    case STANDALONE_DASHBOARD_TYPES.REPORT_MODELS:
      return 'Create Report Model';
  }
};

export const isImportButtonHidden = (dashboardType, hasFormsDesignRight) =>
  [STANDALONE_DASHBOARD_TYPES.SAVED_SEARCHES].includes(dashboardType)
    ? true
    : dashboardType === STANDALONE_DASHBOARD_TYPES.FORMS && !hasFormsDesignRight;

export const isCreateButtonHidden = (dashboardType, hasFormsDesignRight, hasEntityCreateRight) => {
  switch (dashboardType) {
    case STANDALONE_DASHBOARD_TYPES.ENTITIES:
      return !hasEntityCreateRight;
    case STANDALONE_DASHBOARD_TYPES.FORMS:
      return !hasFormsDesignRight;
    case STANDALONE_DASHBOARD_TYPES.SAVED_SEARCHES:
    case STANDALONE_DASHBOARD_TYPES.REPORTS:
    case STANDALONE_DASHBOARD_TYPES.REPORT_MODELS:
      return false;
  }
};

export const validateXmlMethod = {
  [STANDALONE_DASHBOARD_TYPES.ENTITIES]: validateEntityXml,
  [STANDALONE_DASHBOARD_TYPES.FORMS]: validateFormXml,
  [STANDALONE_DASHBOARD_TYPES.REPORT_MODELS]: validateReportModelXml,
  [STANDALONE_DASHBOARD_TYPES.REPORTS]: validateReportXml,
};
